/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SettingsRouteImport } from './routes/settings'
import { Route as PairRouteImport } from './routes/pair'
import { Route as ConnectRouteImport } from './routes/connect'
import { Route as ChatRouteImport } from './routes/_chat'
import { Route as ChatIndexRouteImport } from './routes/_chat.index'
import { Route as WWorkspaceIdRouteImport } from './routes/w.$workspaceId'
import { Route as SettingsSourceControlRouteImport } from './routes/settings.source-control'
import { Route as SettingsProvidersRouteImport } from './routes/settings.providers'
import { Route as SettingsKeybindingsRouteImport } from './routes/settings.keybindings'
import { Route as SettingsGeneralRouteImport } from './routes/settings.general'
import { Route as SettingsDiagnosticsRouteImport } from './routes/settings.diagnostics'
import { Route as SettingsConnectionsRouteImport } from './routes/settings.connections'
import { Route as SettingsBetaRouteImport } from './routes/settings.beta'
import { Route as SettingsArchivedRouteImport } from './routes/settings.archived'
import { Route as SettingsAccountRouteImport } from './routes/settings.account'
import { Route as ConnectCallbackRouteImport } from './routes/connect_.callback'
import { Route as WWorkspaceIdIndexRouteImport } from './routes/w.$workspaceId.index'
import { Route as WWorkspaceIdUsageRouteImport } from './routes/w.$workspaceId.usage'
import { Route as WWorkspaceIdOverviewRouteImport } from './routes/w.$workspaceId.overview'
import { Route as WWorkspaceIdMemoryRouteImport } from './routes/w.$workspaceId.memory'
import { Route as WWorkspaceIdCustomizeRouteImport } from './routes/w.$workspaceId.customize'
import { Route as WWorkspaceIdConnectedWorkRouteImport } from './routes/w.$workspaceId.connected-work'
import { Route as ChatDraftDraftIdRouteImport } from './routes/_chat.draft.$draftId'
import { Route as ChatEnvironmentIdThreadIdRouteImport } from './routes/_chat.$environmentId.$threadId'
import { Route as WWorkspaceIdWorkflowsIndexRouteImport } from './routes/w.$workspaceId.workflows.index'
import { Route as WWorkspaceIdSkillsIndexRouteImport } from './routes/w.$workspaceId.skills.index'
import { Route as WWorkspaceIdScheduleIndexRouteImport } from './routes/w.$workspaceId.schedule.index'
import { Route as WWorkspaceIdProductionIndexRouteImport } from './routes/w.$workspaceId.production.index'
import { Route as WWorkspaceIdPeopleIndexRouteImport } from './routes/w.$workspaceId.people.index'
import { Route as WWorkspaceIdNotificationsIndexRouteImport } from './routes/w.$workspaceId.notifications.index'
import { Route as WWorkspaceIdConnectorsIndexRouteImport } from './routes/w.$workspaceId.connectors.index'
import { Route as WWorkspaceIdAutomationsIndexRouteImport } from './routes/w.$workspaceId.automations.index'
import { Route as WWorkspaceIdAgentsIndexRouteImport } from './routes/w.$workspaceId.agents.index'
import { Route as WWorkspaceIdWorkflowsWorkflowIdRouteImport } from './routes/w.$workspaceId.workflows.$workflowId'
import { Route as WWorkspaceIdSkillsSkillIdRouteImport } from './routes/w.$workspaceId.skills.$skillId'
import { Route as WWorkspaceIdScheduleAutomationIdRouteImport } from './routes/w.$workspaceId.schedule.$automationId'
import { Route as WWorkspaceIdProductionAppIdRouteImport } from './routes/w.$workspaceId.production.$appId'
import { Route as WWorkspaceIdConversationsConversationIdRouteImport } from './routes/w.$workspaceId.conversations.$conversationId'
import { Route as WWorkspaceIdChannelsManageRouteImport } from './routes/w.$workspaceId.channels.manage'
import { Route as WWorkspaceIdChannelsChannelIdRouteImport } from './routes/w.$workspaceId.channels.$channelId'
import { Route as WWorkspaceIdAutomationsAutomationIdRouteImport } from './routes/w.$workspaceId.automations.$automationId'
import { Route as WWorkspaceIdAgentsAgentIdRouteImport } from './routes/w.$workspaceId.agents.$agentId'

const SettingsRoute = SettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const PairRoute = PairRouteImport.update({
  id: '/pair',
  path: '/pair',
  getParentRoute: () => rootRouteImport,
} as any)
const ConnectRoute = ConnectRouteImport.update({
  id: '/connect',
  path: '/connect',
  getParentRoute: () => rootRouteImport,
} as any)
const ChatRoute = ChatRouteImport.update({
  id: '/_chat',
  getParentRoute: () => rootRouteImport,
} as any)
const ChatIndexRoute = ChatIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ChatRoute,
} as any)
const WWorkspaceIdRoute = WWorkspaceIdRouteImport.update({
  id: '/w/$workspaceId',
  path: '/w/$workspaceId',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsSourceControlRoute = SettingsSourceControlRouteImport.update({
  id: '/source-control',
  path: '/source-control',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsProvidersRoute = SettingsProvidersRouteImport.update({
  id: '/providers',
  path: '/providers',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsKeybindingsRoute = SettingsKeybindingsRouteImport.update({
  id: '/keybindings',
  path: '/keybindings',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsGeneralRoute = SettingsGeneralRouteImport.update({
  id: '/general',
  path: '/general',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsDiagnosticsRoute = SettingsDiagnosticsRouteImport.update({
  id: '/diagnostics',
  path: '/diagnostics',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsConnectionsRoute = SettingsConnectionsRouteImport.update({
  id: '/connections',
  path: '/connections',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsBetaRoute = SettingsBetaRouteImport.update({
  id: '/beta',
  path: '/beta',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsArchivedRoute = SettingsArchivedRouteImport.update({
  id: '/archived',
  path: '/archived',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsAccountRoute = SettingsAccountRouteImport.update({
  id: '/account',
  path: '/account',
  getParentRoute: () => SettingsRoute,
} as any)
const ConnectCallbackRoute = ConnectCallbackRouteImport.update({
  id: '/connect_/callback',
  path: '/connect/callback',
  getParentRoute: () => rootRouteImport,
} as any)
const WWorkspaceIdIndexRoute = WWorkspaceIdIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => WWorkspaceIdRoute,
} as any)
const WWorkspaceIdUsageRoute = WWorkspaceIdUsageRouteImport.update({
  id: '/usage',
  path: '/usage',
  getParentRoute: () => WWorkspaceIdRoute,
} as any)
const WWorkspaceIdOverviewRoute = WWorkspaceIdOverviewRouteImport.update({
  id: '/overview',
  path: '/overview',
  getParentRoute: () => WWorkspaceIdRoute,
} as any)
const WWorkspaceIdMemoryRoute = WWorkspaceIdMemoryRouteImport.update({
  id: '/memory',
  path: '/memory',
  getParentRoute: () => WWorkspaceIdRoute,
} as any)
const WWorkspaceIdCustomizeRoute = WWorkspaceIdCustomizeRouteImport.update({
  id: '/customize',
  path: '/customize',
  getParentRoute: () => WWorkspaceIdRoute,
} as any)
const WWorkspaceIdConnectedWorkRoute =
  WWorkspaceIdConnectedWorkRouteImport.update({
    id: '/connected-work',
    path: '/connected-work',
    getParentRoute: () => WWorkspaceIdRoute,
  } as any)
const ChatDraftDraftIdRoute = ChatDraftDraftIdRouteImport.update({
  id: '/draft/$draftId',
  path: '/draft/$draftId',
  getParentRoute: () => ChatRoute,
} as any)
const ChatEnvironmentIdThreadIdRoute =
  ChatEnvironmentIdThreadIdRouteImport.update({
    id: '/$environmentId/$threadId',
    path: '/$environmentId/$threadId',
    getParentRoute: () => ChatRoute,
  } as any)
const WWorkspaceIdWorkflowsIndexRoute =
  WWorkspaceIdWorkflowsIndexRouteImport.update({
    id: '/workflows/',
    path: '/workflows/',
    getParentRoute: () => WWorkspaceIdRoute,
  } as any)
const WWorkspaceIdSkillsIndexRoute = WWorkspaceIdSkillsIndexRouteImport.update({
  id: '/skills/',
  path: '/skills/',
  getParentRoute: () => WWorkspaceIdRoute,
} as any)
const WWorkspaceIdScheduleIndexRoute =
  WWorkspaceIdScheduleIndexRouteImport.update({
    id: '/schedule/',
    path: '/schedule/',
    getParentRoute: () => WWorkspaceIdRoute,
  } as any)
const WWorkspaceIdProductionIndexRoute =
  WWorkspaceIdProductionIndexRouteImport.update({
    id: '/production/',
    path: '/production/',
    getParentRoute: () => WWorkspaceIdRoute,
  } as any)
const WWorkspaceIdPeopleIndexRoute = WWorkspaceIdPeopleIndexRouteImport.update({
  id: '/people/',
  path: '/people/',
  getParentRoute: () => WWorkspaceIdRoute,
} as any)
const WWorkspaceIdNotificationsIndexRoute =
  WWorkspaceIdNotificationsIndexRouteImport.update({
    id: '/notifications/',
    path: '/notifications/',
    getParentRoute: () => WWorkspaceIdRoute,
  } as any)
const WWorkspaceIdConnectorsIndexRoute =
  WWorkspaceIdConnectorsIndexRouteImport.update({
    id: '/connectors/',
    path: '/connectors/',
    getParentRoute: () => WWorkspaceIdRoute,
  } as any)
const WWorkspaceIdAutomationsIndexRoute =
  WWorkspaceIdAutomationsIndexRouteImport.update({
    id: '/automations/',
    path: '/automations/',
    getParentRoute: () => WWorkspaceIdRoute,
  } as any)
const WWorkspaceIdAgentsIndexRoute = WWorkspaceIdAgentsIndexRouteImport.update({
  id: '/agents/',
  path: '/agents/',
  getParentRoute: () => WWorkspaceIdRoute,
} as any)
const WWorkspaceIdWorkflowsWorkflowIdRoute =
  WWorkspaceIdWorkflowsWorkflowIdRouteImport.update({
    id: '/workflows/$workflowId',
    path: '/workflows/$workflowId',
    getParentRoute: () => WWorkspaceIdRoute,
  } as any)
const WWorkspaceIdSkillsSkillIdRoute =
  WWorkspaceIdSkillsSkillIdRouteImport.update({
    id: '/skills/$skillId',
    path: '/skills/$skillId',
    getParentRoute: () => WWorkspaceIdRoute,
  } as any)
const WWorkspaceIdScheduleAutomationIdRoute =
  WWorkspaceIdScheduleAutomationIdRouteImport.update({
    id: '/schedule/$automationId',
    path: '/schedule/$automationId',
    getParentRoute: () => WWorkspaceIdRoute,
  } as any)
const WWorkspaceIdProductionAppIdRoute =
  WWorkspaceIdProductionAppIdRouteImport.update({
    id: '/production/$appId',
    path: '/production/$appId',
    getParentRoute: () => WWorkspaceIdRoute,
  } as any)
const WWorkspaceIdConversationsConversationIdRoute =
  WWorkspaceIdConversationsConversationIdRouteImport.update({
    id: '/conversations/$conversationId',
    path: '/conversations/$conversationId',
    getParentRoute: () => WWorkspaceIdRoute,
  } as any)
const WWorkspaceIdChannelsManageRoute =
  WWorkspaceIdChannelsManageRouteImport.update({
    id: '/channels/manage',
    path: '/channels/manage',
    getParentRoute: () => WWorkspaceIdRoute,
  } as any)
const WWorkspaceIdChannelsChannelIdRoute =
  WWorkspaceIdChannelsChannelIdRouteImport.update({
    id: '/channels/$channelId',
    path: '/channels/$channelId',
    getParentRoute: () => WWorkspaceIdRoute,
  } as any)
const WWorkspaceIdAutomationsAutomationIdRoute =
  WWorkspaceIdAutomationsAutomationIdRouteImport.update({
    id: '/automations/$automationId',
    path: '/automations/$automationId',
    getParentRoute: () => WWorkspaceIdRoute,
  } as any)
const WWorkspaceIdAgentsAgentIdRoute =
  WWorkspaceIdAgentsAgentIdRouteImport.update({
    id: '/agents/$agentId',
    path: '/agents/$agentId',
    getParentRoute: () => WWorkspaceIdRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof ChatIndexRoute
  '/connect': typeof ConnectRoute
  '/pair': typeof PairRoute
  '/settings': typeof SettingsRouteWithChildren
  '/connect/callback': typeof ConnectCallbackRoute
  '/settings/account': typeof SettingsAccountRoute
  '/settings/archived': typeof SettingsArchivedRoute
  '/settings/beta': typeof SettingsBetaRoute
  '/settings/connections': typeof SettingsConnectionsRoute
  '/settings/diagnostics': typeof SettingsDiagnosticsRoute
  '/settings/general': typeof SettingsGeneralRoute
  '/settings/keybindings': typeof SettingsKeybindingsRoute
  '/settings/providers': typeof SettingsProvidersRoute
  '/settings/source-control': typeof SettingsSourceControlRoute
  '/w/$workspaceId': typeof WWorkspaceIdRouteWithChildren
  '/$environmentId/$threadId': typeof ChatEnvironmentIdThreadIdRoute
  '/draft/$draftId': typeof ChatDraftDraftIdRoute
  '/w/$workspaceId/connected-work': typeof WWorkspaceIdConnectedWorkRoute
  '/w/$workspaceId/customize': typeof WWorkspaceIdCustomizeRoute
  '/w/$workspaceId/memory': typeof WWorkspaceIdMemoryRoute
  '/w/$workspaceId/overview': typeof WWorkspaceIdOverviewRoute
  '/w/$workspaceId/usage': typeof WWorkspaceIdUsageRoute
  '/w/$workspaceId/': typeof WWorkspaceIdIndexRoute
  '/w/$workspaceId/agents/$agentId': typeof WWorkspaceIdAgentsAgentIdRoute
  '/w/$workspaceId/automations/$automationId': typeof WWorkspaceIdAutomationsAutomationIdRoute
  '/w/$workspaceId/channels/$channelId': typeof WWorkspaceIdChannelsChannelIdRoute
  '/w/$workspaceId/channels/manage': typeof WWorkspaceIdChannelsManageRoute
  '/w/$workspaceId/conversations/$conversationId': typeof WWorkspaceIdConversationsConversationIdRoute
  '/w/$workspaceId/production/$appId': typeof WWorkspaceIdProductionAppIdRoute
  '/w/$workspaceId/schedule/$automationId': typeof WWorkspaceIdScheduleAutomationIdRoute
  '/w/$workspaceId/skills/$skillId': typeof WWorkspaceIdSkillsSkillIdRoute
  '/w/$workspaceId/workflows/$workflowId': typeof WWorkspaceIdWorkflowsWorkflowIdRoute
  '/w/$workspaceId/agents/': typeof WWorkspaceIdAgentsIndexRoute
  '/w/$workspaceId/automations/': typeof WWorkspaceIdAutomationsIndexRoute
  '/w/$workspaceId/connectors/': typeof WWorkspaceIdConnectorsIndexRoute
  '/w/$workspaceId/notifications/': typeof WWorkspaceIdNotificationsIndexRoute
  '/w/$workspaceId/people/': typeof WWorkspaceIdPeopleIndexRoute
  '/w/$workspaceId/production/': typeof WWorkspaceIdProductionIndexRoute
  '/w/$workspaceId/schedule/': typeof WWorkspaceIdScheduleIndexRoute
  '/w/$workspaceId/skills/': typeof WWorkspaceIdSkillsIndexRoute
  '/w/$workspaceId/workflows/': typeof WWorkspaceIdWorkflowsIndexRoute
}
export interface FileRoutesByTo {
  '/connect': typeof ConnectRoute
  '/pair': typeof PairRoute
  '/settings': typeof SettingsRouteWithChildren
  '/connect/callback': typeof ConnectCallbackRoute
  '/settings/account': typeof SettingsAccountRoute
  '/settings/archived': typeof SettingsArchivedRoute
  '/settings/beta': typeof SettingsBetaRoute
  '/settings/connections': typeof SettingsConnectionsRoute
  '/settings/diagnostics': typeof SettingsDiagnosticsRoute
  '/settings/general': typeof SettingsGeneralRoute
  '/settings/keybindings': typeof SettingsKeybindingsRoute
  '/settings/providers': typeof SettingsProvidersRoute
  '/settings/source-control': typeof SettingsSourceControlRoute
  '/': typeof ChatIndexRoute
  '/$environmentId/$threadId': typeof ChatEnvironmentIdThreadIdRoute
  '/draft/$draftId': typeof ChatDraftDraftIdRoute
  '/w/$workspaceId/connected-work': typeof WWorkspaceIdConnectedWorkRoute
  '/w/$workspaceId/customize': typeof WWorkspaceIdCustomizeRoute
  '/w/$workspaceId/memory': typeof WWorkspaceIdMemoryRoute
  '/w/$workspaceId/overview': typeof WWorkspaceIdOverviewRoute
  '/w/$workspaceId/usage': typeof WWorkspaceIdUsageRoute
  '/w/$workspaceId': typeof WWorkspaceIdIndexRoute
  '/w/$workspaceId/agents/$agentId': typeof WWorkspaceIdAgentsAgentIdRoute
  '/w/$workspaceId/automations/$automationId': typeof WWorkspaceIdAutomationsAutomationIdRoute
  '/w/$workspaceId/channels/$channelId': typeof WWorkspaceIdChannelsChannelIdRoute
  '/w/$workspaceId/channels/manage': typeof WWorkspaceIdChannelsManageRoute
  '/w/$workspaceId/conversations/$conversationId': typeof WWorkspaceIdConversationsConversationIdRoute
  '/w/$workspaceId/production/$appId': typeof WWorkspaceIdProductionAppIdRoute
  '/w/$workspaceId/schedule/$automationId': typeof WWorkspaceIdScheduleAutomationIdRoute
  '/w/$workspaceId/skills/$skillId': typeof WWorkspaceIdSkillsSkillIdRoute
  '/w/$workspaceId/workflows/$workflowId': typeof WWorkspaceIdWorkflowsWorkflowIdRoute
  '/w/$workspaceId/agents': typeof WWorkspaceIdAgentsIndexRoute
  '/w/$workspaceId/automations': typeof WWorkspaceIdAutomationsIndexRoute
  '/w/$workspaceId/connectors': typeof WWorkspaceIdConnectorsIndexRoute
  '/w/$workspaceId/notifications': typeof WWorkspaceIdNotificationsIndexRoute
  '/w/$workspaceId/people': typeof WWorkspaceIdPeopleIndexRoute
  '/w/$workspaceId/production': typeof WWorkspaceIdProductionIndexRoute
  '/w/$workspaceId/schedule': typeof WWorkspaceIdScheduleIndexRoute
  '/w/$workspaceId/skills': typeof WWorkspaceIdSkillsIndexRoute
  '/w/$workspaceId/workflows': typeof WWorkspaceIdWorkflowsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_chat': typeof ChatRouteWithChildren
  '/connect': typeof ConnectRoute
  '/pair': typeof PairRoute
  '/settings': typeof SettingsRouteWithChildren
  '/connect_/callback': typeof ConnectCallbackRoute
  '/settings/account': typeof SettingsAccountRoute
  '/settings/archived': typeof SettingsArchivedRoute
  '/settings/beta': typeof SettingsBetaRoute
  '/settings/connections': typeof SettingsConnectionsRoute
  '/settings/diagnostics': typeof SettingsDiagnosticsRoute
  '/settings/general': typeof SettingsGeneralRoute
  '/settings/keybindings': typeof SettingsKeybindingsRoute
  '/settings/providers': typeof SettingsProvidersRoute
  '/settings/source-control': typeof SettingsSourceControlRoute
  '/w/$workspaceId': typeof WWorkspaceIdRouteWithChildren
  '/_chat/': typeof ChatIndexRoute
  '/_chat/$environmentId/$threadId': typeof ChatEnvironmentIdThreadIdRoute
  '/_chat/draft/$draftId': typeof ChatDraftDraftIdRoute
  '/w/$workspaceId/connected-work': typeof WWorkspaceIdConnectedWorkRoute
  '/w/$workspaceId/customize': typeof WWorkspaceIdCustomizeRoute
  '/w/$workspaceId/memory': typeof WWorkspaceIdMemoryRoute
  '/w/$workspaceId/overview': typeof WWorkspaceIdOverviewRoute
  '/w/$workspaceId/usage': typeof WWorkspaceIdUsageRoute
  '/w/$workspaceId/': typeof WWorkspaceIdIndexRoute
  '/w/$workspaceId/agents/$agentId': typeof WWorkspaceIdAgentsAgentIdRoute
  '/w/$workspaceId/automations/$automationId': typeof WWorkspaceIdAutomationsAutomationIdRoute
  '/w/$workspaceId/channels/$channelId': typeof WWorkspaceIdChannelsChannelIdRoute
  '/w/$workspaceId/channels/manage': typeof WWorkspaceIdChannelsManageRoute
  '/w/$workspaceId/conversations/$conversationId': typeof WWorkspaceIdConversationsConversationIdRoute
  '/w/$workspaceId/production/$appId': typeof WWorkspaceIdProductionAppIdRoute
  '/w/$workspaceId/schedule/$automationId': typeof WWorkspaceIdScheduleAutomationIdRoute
  '/w/$workspaceId/skills/$skillId': typeof WWorkspaceIdSkillsSkillIdRoute
  '/w/$workspaceId/workflows/$workflowId': typeof WWorkspaceIdWorkflowsWorkflowIdRoute
  '/w/$workspaceId/agents/': typeof WWorkspaceIdAgentsIndexRoute
  '/w/$workspaceId/automations/': typeof WWorkspaceIdAutomationsIndexRoute
  '/w/$workspaceId/connectors/': typeof WWorkspaceIdConnectorsIndexRoute
  '/w/$workspaceId/notifications/': typeof WWorkspaceIdNotificationsIndexRoute
  '/w/$workspaceId/people/': typeof WWorkspaceIdPeopleIndexRoute
  '/w/$workspaceId/production/': typeof WWorkspaceIdProductionIndexRoute
  '/w/$workspaceId/schedule/': typeof WWorkspaceIdScheduleIndexRoute
  '/w/$workspaceId/skills/': typeof WWorkspaceIdSkillsIndexRoute
  '/w/$workspaceId/workflows/': typeof WWorkspaceIdWorkflowsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/connect'
    | '/pair'
    | '/settings'
    | '/connect/callback'
    | '/settings/account'
    | '/settings/archived'
    | '/settings/beta'
    | '/settings/connections'
    | '/settings/diagnostics'
    | '/settings/general'
    | '/settings/keybindings'
    | '/settings/providers'
    | '/settings/source-control'
    | '/w/$workspaceId'
    | '/$environmentId/$threadId'
    | '/draft/$draftId'
    | '/w/$workspaceId/connected-work'
    | '/w/$workspaceId/customize'
    | '/w/$workspaceId/memory'
    | '/w/$workspaceId/overview'
    | '/w/$workspaceId/usage'
    | '/w/$workspaceId/'
    | '/w/$workspaceId/agents/$agentId'
    | '/w/$workspaceId/automations/$automationId'
    | '/w/$workspaceId/channels/$channelId'
    | '/w/$workspaceId/channels/manage'
    | '/w/$workspaceId/conversations/$conversationId'
    | '/w/$workspaceId/production/$appId'
    | '/w/$workspaceId/schedule/$automationId'
    | '/w/$workspaceId/skills/$skillId'
    | '/w/$workspaceId/workflows/$workflowId'
    | '/w/$workspaceId/agents/'
    | '/w/$workspaceId/automations/'
    | '/w/$workspaceId/connectors/'
    | '/w/$workspaceId/notifications/'
    | '/w/$workspaceId/people/'
    | '/w/$workspaceId/production/'
    | '/w/$workspaceId/schedule/'
    | '/w/$workspaceId/skills/'
    | '/w/$workspaceId/workflows/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/connect'
    | '/pair'
    | '/settings'
    | '/connect/callback'
    | '/settings/account'
    | '/settings/archived'
    | '/settings/beta'
    | '/settings/connections'
    | '/settings/diagnostics'
    | '/settings/general'
    | '/settings/keybindings'
    | '/settings/providers'
    | '/settings/source-control'
    | '/'
    | '/$environmentId/$threadId'
    | '/draft/$draftId'
    | '/w/$workspaceId/connected-work'
    | '/w/$workspaceId/customize'
    | '/w/$workspaceId/memory'
    | '/w/$workspaceId/overview'
    | '/w/$workspaceId/usage'
    | '/w/$workspaceId'
    | '/w/$workspaceId/agents/$agentId'
    | '/w/$workspaceId/automations/$automationId'
    | '/w/$workspaceId/channels/$channelId'
    | '/w/$workspaceId/channels/manage'
    | '/w/$workspaceId/conversations/$conversationId'
    | '/w/$workspaceId/production/$appId'
    | '/w/$workspaceId/schedule/$automationId'
    | '/w/$workspaceId/skills/$skillId'
    | '/w/$workspaceId/workflows/$workflowId'
    | '/w/$workspaceId/agents'
    | '/w/$workspaceId/automations'
    | '/w/$workspaceId/connectors'
    | '/w/$workspaceId/notifications'
    | '/w/$workspaceId/people'
    | '/w/$workspaceId/production'
    | '/w/$workspaceId/schedule'
    | '/w/$workspaceId/skills'
    | '/w/$workspaceId/workflows'
  id:
    | '__root__'
    | '/_chat'
    | '/connect'
    | '/pair'
    | '/settings'
    | '/connect_/callback'
    | '/settings/account'
    | '/settings/archived'
    | '/settings/beta'
    | '/settings/connections'
    | '/settings/diagnostics'
    | '/settings/general'
    | '/settings/keybindings'
    | '/settings/providers'
    | '/settings/source-control'
    | '/w/$workspaceId'
    | '/_chat/'
    | '/_chat/$environmentId/$threadId'
    | '/_chat/draft/$draftId'
    | '/w/$workspaceId/connected-work'
    | '/w/$workspaceId/customize'
    | '/w/$workspaceId/memory'
    | '/w/$workspaceId/overview'
    | '/w/$workspaceId/usage'
    | '/w/$workspaceId/'
    | '/w/$workspaceId/agents/$agentId'
    | '/w/$workspaceId/automations/$automationId'
    | '/w/$workspaceId/channels/$channelId'
    | '/w/$workspaceId/channels/manage'
    | '/w/$workspaceId/conversations/$conversationId'
    | '/w/$workspaceId/production/$appId'
    | '/w/$workspaceId/schedule/$automationId'
    | '/w/$workspaceId/skills/$skillId'
    | '/w/$workspaceId/workflows/$workflowId'
    | '/w/$workspaceId/agents/'
    | '/w/$workspaceId/automations/'
    | '/w/$workspaceId/connectors/'
    | '/w/$workspaceId/notifications/'
    | '/w/$workspaceId/people/'
    | '/w/$workspaceId/production/'
    | '/w/$workspaceId/schedule/'
    | '/w/$workspaceId/skills/'
    | '/w/$workspaceId/workflows/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  ChatRoute: typeof ChatRouteWithChildren
  ConnectRoute: typeof ConnectRoute
  PairRoute: typeof PairRoute
  SettingsRoute: typeof SettingsRouteWithChildren
  ConnectCallbackRoute: typeof ConnectCallbackRoute
  WWorkspaceIdRoute: typeof WWorkspaceIdRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/settings': {
      id: '/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/pair': {
      id: '/pair'
      path: '/pair'
      fullPath: '/pair'
      preLoaderRoute: typeof PairRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/connect': {
      id: '/connect'
      path: '/connect'
      fullPath: '/connect'
      preLoaderRoute: typeof ConnectRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_chat': {
      id: '/_chat'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof ChatRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_chat/': {
      id: '/_chat/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof ChatIndexRouteImport
      parentRoute: typeof ChatRoute
    }
    '/w/$workspaceId': {
      id: '/w/$workspaceId'
      path: '/w/$workspaceId'
      fullPath: '/w/$workspaceId'
      preLoaderRoute: typeof WWorkspaceIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/source-control': {
      id: '/settings/source-control'
      path: '/source-control'
      fullPath: '/settings/source-control'
      preLoaderRoute: typeof SettingsSourceControlRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/providers': {
      id: '/settings/providers'
      path: '/providers'
      fullPath: '/settings/providers'
      preLoaderRoute: typeof SettingsProvidersRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/keybindings': {
      id: '/settings/keybindings'
      path: '/keybindings'
      fullPath: '/settings/keybindings'
      preLoaderRoute: typeof SettingsKeybindingsRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/general': {
      id: '/settings/general'
      path: '/general'
      fullPath: '/settings/general'
      preLoaderRoute: typeof SettingsGeneralRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/diagnostics': {
      id: '/settings/diagnostics'
      path: '/diagnostics'
      fullPath: '/settings/diagnostics'
      preLoaderRoute: typeof SettingsDiagnosticsRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/connections': {
      id: '/settings/connections'
      path: '/connections'
      fullPath: '/settings/connections'
      preLoaderRoute: typeof SettingsConnectionsRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/beta': {
      id: '/settings/beta'
      path: '/beta'
      fullPath: '/settings/beta'
      preLoaderRoute: typeof SettingsBetaRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/archived': {
      id: '/settings/archived'
      path: '/archived'
      fullPath: '/settings/archived'
      preLoaderRoute: typeof SettingsArchivedRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/account': {
      id: '/settings/account'
      path: '/account'
      fullPath: '/settings/account'
      preLoaderRoute: typeof SettingsAccountRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/connect_/callback': {
      id: '/connect_/callback'
      path: '/connect/callback'
      fullPath: '/connect/callback'
      preLoaderRoute: typeof ConnectCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/w/$workspaceId/': {
      id: '/w/$workspaceId/'
      path: '/'
      fullPath: '/w/$workspaceId/'
      preLoaderRoute: typeof WWorkspaceIdIndexRouteImport
      parentRoute: typeof WWorkspaceIdRoute
    }
    '/w/$workspaceId/usage': {
      id: '/w/$workspaceId/usage'
      path: '/usage'
      fullPath: '/w/$workspaceId/usage'
      preLoaderRoute: typeof WWorkspaceIdUsageRouteImport
      parentRoute: typeof WWorkspaceIdRoute
    }
    '/w/$workspaceId/overview': {
      id: '/w/$workspaceId/overview'
      path: '/overview'
      fullPath: '/w/$workspaceId/overview'
      preLoaderRoute: typeof WWorkspaceIdOverviewRouteImport
      parentRoute: typeof WWorkspaceIdRoute
    }
    '/w/$workspaceId/memory': {
      id: '/w/$workspaceId/memory'
      path: '/memory'
      fullPath: '/w/$workspaceId/memory'
      preLoaderRoute: typeof WWorkspaceIdMemoryRouteImport
      parentRoute: typeof WWorkspaceIdRoute
    }
    '/w/$workspaceId/customize': {
      id: '/w/$workspaceId/customize'
      path: '/customize'
      fullPath: '/w/$workspaceId/customize'
      preLoaderRoute: typeof WWorkspaceIdCustomizeRouteImport
      parentRoute: typeof WWorkspaceIdRoute
    }
    '/w/$workspaceId/connected-work': {
      id: '/w/$workspaceId/connected-work'
      path: '/connected-work'
      fullPath: '/w/$workspaceId/connected-work'
      preLoaderRoute: typeof WWorkspaceIdConnectedWorkRouteImport
      parentRoute: typeof WWorkspaceIdRoute
    }
    '/_chat/draft/$draftId': {
      id: '/_chat/draft/$draftId'
      path: '/draft/$draftId'
      fullPath: '/draft/$draftId'
      preLoaderRoute: typeof ChatDraftDraftIdRouteImport
      parentRoute: typeof ChatRoute
    }
    '/_chat/$environmentId/$threadId': {
      id: '/_chat/$environmentId/$threadId'
      path: '/$environmentId/$threadId'
      fullPath: '/$environmentId/$threadId'
      preLoaderRoute: typeof ChatEnvironmentIdThreadIdRouteImport
      parentRoute: typeof ChatRoute
    }
    '/w/$workspaceId/workflows/': {
      id: '/w/$workspaceId/workflows/'
      path: '/workflows'
      fullPath: '/w/$workspaceId/workflows/'
      preLoaderRoute: typeof WWorkspaceIdWorkflowsIndexRouteImport
      parentRoute: typeof WWorkspaceIdRoute
    }
    '/w/$workspaceId/skills/': {
      id: '/w/$workspaceId/skills/'
      path: '/skills'
      fullPath: '/w/$workspaceId/skills/'
      preLoaderRoute: typeof WWorkspaceIdSkillsIndexRouteImport
      parentRoute: typeof WWorkspaceIdRoute
    }
    '/w/$workspaceId/schedule/': {
      id: '/w/$workspaceId/schedule/'
      path: '/schedule'
      fullPath: '/w/$workspaceId/schedule/'
      preLoaderRoute: typeof WWorkspaceIdScheduleIndexRouteImport
      parentRoute: typeof WWorkspaceIdRoute
    }
    '/w/$workspaceId/production/': {
      id: '/w/$workspaceId/production/'
      path: '/production'
      fullPath: '/w/$workspaceId/production/'
      preLoaderRoute: typeof WWorkspaceIdProductionIndexRouteImport
      parentRoute: typeof WWorkspaceIdRoute
    }
    '/w/$workspaceId/people/': {
      id: '/w/$workspaceId/people/'
      path: '/people'
      fullPath: '/w/$workspaceId/people/'
      preLoaderRoute: typeof WWorkspaceIdPeopleIndexRouteImport
      parentRoute: typeof WWorkspaceIdRoute
    }
    '/w/$workspaceId/notifications/': {
      id: '/w/$workspaceId/notifications/'
      path: '/notifications'
      fullPath: '/w/$workspaceId/notifications/'
      preLoaderRoute: typeof WWorkspaceIdNotificationsIndexRouteImport
      parentRoute: typeof WWorkspaceIdRoute
    }
    '/w/$workspaceId/connectors/': {
      id: '/w/$workspaceId/connectors/'
      path: '/connectors'
      fullPath: '/w/$workspaceId/connectors/'
      preLoaderRoute: typeof WWorkspaceIdConnectorsIndexRouteImport
      parentRoute: typeof WWorkspaceIdRoute
    }
    '/w/$workspaceId/automations/': {
      id: '/w/$workspaceId/automations/'
      path: '/automations'
      fullPath: '/w/$workspaceId/automations/'
      preLoaderRoute: typeof WWorkspaceIdAutomationsIndexRouteImport
      parentRoute: typeof WWorkspaceIdRoute
    }
    '/w/$workspaceId/agents/': {
      id: '/w/$workspaceId/agents/'
      path: '/agents'
      fullPath: '/w/$workspaceId/agents/'
      preLoaderRoute: typeof WWorkspaceIdAgentsIndexRouteImport
      parentRoute: typeof WWorkspaceIdRoute
    }
    '/w/$workspaceId/workflows/$workflowId': {
      id: '/w/$workspaceId/workflows/$workflowId'
      path: '/workflows/$workflowId'
      fullPath: '/w/$workspaceId/workflows/$workflowId'
      preLoaderRoute: typeof WWorkspaceIdWorkflowsWorkflowIdRouteImport
      parentRoute: typeof WWorkspaceIdRoute
    }
    '/w/$workspaceId/skills/$skillId': {
      id: '/w/$workspaceId/skills/$skillId'
      path: '/skills/$skillId'
      fullPath: '/w/$workspaceId/skills/$skillId'
      preLoaderRoute: typeof WWorkspaceIdSkillsSkillIdRouteImport
      parentRoute: typeof WWorkspaceIdRoute
    }
    '/w/$workspaceId/schedule/$automationId': {
      id: '/w/$workspaceId/schedule/$automationId'
      path: '/schedule/$automationId'
      fullPath: '/w/$workspaceId/schedule/$automationId'
      preLoaderRoute: typeof WWorkspaceIdScheduleAutomationIdRouteImport
      parentRoute: typeof WWorkspaceIdRoute
    }
    '/w/$workspaceId/production/$appId': {
      id: '/w/$workspaceId/production/$appId'
      path: '/production/$appId'
      fullPath: '/w/$workspaceId/production/$appId'
      preLoaderRoute: typeof WWorkspaceIdProductionAppIdRouteImport
      parentRoute: typeof WWorkspaceIdRoute
    }
    '/w/$workspaceId/conversations/$conversationId': {
      id: '/w/$workspaceId/conversations/$conversationId'
      path: '/conversations/$conversationId'
      fullPath: '/w/$workspaceId/conversations/$conversationId'
      preLoaderRoute: typeof WWorkspaceIdConversationsConversationIdRouteImport
      parentRoute: typeof WWorkspaceIdRoute
    }
    '/w/$workspaceId/channels/manage': {
      id: '/w/$workspaceId/channels/manage'
      path: '/channels/manage'
      fullPath: '/w/$workspaceId/channels/manage'
      preLoaderRoute: typeof WWorkspaceIdChannelsManageRouteImport
      parentRoute: typeof WWorkspaceIdRoute
    }
    '/w/$workspaceId/channels/$channelId': {
      id: '/w/$workspaceId/channels/$channelId'
      path: '/channels/$channelId'
      fullPath: '/w/$workspaceId/channels/$channelId'
      preLoaderRoute: typeof WWorkspaceIdChannelsChannelIdRouteImport
      parentRoute: typeof WWorkspaceIdRoute
    }
    '/w/$workspaceId/automations/$automationId': {
      id: '/w/$workspaceId/automations/$automationId'
      path: '/automations/$automationId'
      fullPath: '/w/$workspaceId/automations/$automationId'
      preLoaderRoute: typeof WWorkspaceIdAutomationsAutomationIdRouteImport
      parentRoute: typeof WWorkspaceIdRoute
    }
    '/w/$workspaceId/agents/$agentId': {
      id: '/w/$workspaceId/agents/$agentId'
      path: '/agents/$agentId'
      fullPath: '/w/$workspaceId/agents/$agentId'
      preLoaderRoute: typeof WWorkspaceIdAgentsAgentIdRouteImport
      parentRoute: typeof WWorkspaceIdRoute
    }
  }
}

interface ChatRouteChildren {
  ChatIndexRoute: typeof ChatIndexRoute
  ChatEnvironmentIdThreadIdRoute: typeof ChatEnvironmentIdThreadIdRoute
  ChatDraftDraftIdRoute: typeof ChatDraftDraftIdRoute
}

const ChatRouteChildren: ChatRouteChildren = {
  ChatIndexRoute: ChatIndexRoute,
  ChatEnvironmentIdThreadIdRoute: ChatEnvironmentIdThreadIdRoute,
  ChatDraftDraftIdRoute: ChatDraftDraftIdRoute,
}

const ChatRouteWithChildren = ChatRoute._addFileChildren(ChatRouteChildren)

interface SettingsRouteChildren {
  SettingsAccountRoute: typeof SettingsAccountRoute
  SettingsArchivedRoute: typeof SettingsArchivedRoute
  SettingsBetaRoute: typeof SettingsBetaRoute
  SettingsConnectionsRoute: typeof SettingsConnectionsRoute
  SettingsDiagnosticsRoute: typeof SettingsDiagnosticsRoute
  SettingsGeneralRoute: typeof SettingsGeneralRoute
  SettingsKeybindingsRoute: typeof SettingsKeybindingsRoute
  SettingsProvidersRoute: typeof SettingsProvidersRoute
  SettingsSourceControlRoute: typeof SettingsSourceControlRoute
}

const SettingsRouteChildren: SettingsRouteChildren = {
  SettingsAccountRoute: SettingsAccountRoute,
  SettingsArchivedRoute: SettingsArchivedRoute,
  SettingsBetaRoute: SettingsBetaRoute,
  SettingsConnectionsRoute: SettingsConnectionsRoute,
  SettingsDiagnosticsRoute: SettingsDiagnosticsRoute,
  SettingsGeneralRoute: SettingsGeneralRoute,
  SettingsKeybindingsRoute: SettingsKeybindingsRoute,
  SettingsProvidersRoute: SettingsProvidersRoute,
  SettingsSourceControlRoute: SettingsSourceControlRoute,
}

const SettingsRouteWithChildren = SettingsRoute._addFileChildren(
  SettingsRouteChildren,
)

interface WWorkspaceIdRouteChildren {
  WWorkspaceIdConnectedWorkRoute: typeof WWorkspaceIdConnectedWorkRoute
  WWorkspaceIdCustomizeRoute: typeof WWorkspaceIdCustomizeRoute
  WWorkspaceIdMemoryRoute: typeof WWorkspaceIdMemoryRoute
  WWorkspaceIdOverviewRoute: typeof WWorkspaceIdOverviewRoute
  WWorkspaceIdUsageRoute: typeof WWorkspaceIdUsageRoute
  WWorkspaceIdIndexRoute: typeof WWorkspaceIdIndexRoute
  WWorkspaceIdAgentsAgentIdRoute: typeof WWorkspaceIdAgentsAgentIdRoute
  WWorkspaceIdAutomationsAutomationIdRoute: typeof WWorkspaceIdAutomationsAutomationIdRoute
  WWorkspaceIdChannelsChannelIdRoute: typeof WWorkspaceIdChannelsChannelIdRoute
  WWorkspaceIdChannelsManageRoute: typeof WWorkspaceIdChannelsManageRoute
  WWorkspaceIdConversationsConversationIdRoute: typeof WWorkspaceIdConversationsConversationIdRoute
  WWorkspaceIdProductionAppIdRoute: typeof WWorkspaceIdProductionAppIdRoute
  WWorkspaceIdScheduleAutomationIdRoute: typeof WWorkspaceIdScheduleAutomationIdRoute
  WWorkspaceIdSkillsSkillIdRoute: typeof WWorkspaceIdSkillsSkillIdRoute
  WWorkspaceIdWorkflowsWorkflowIdRoute: typeof WWorkspaceIdWorkflowsWorkflowIdRoute
  WWorkspaceIdAgentsIndexRoute: typeof WWorkspaceIdAgentsIndexRoute
  WWorkspaceIdAutomationsIndexRoute: typeof WWorkspaceIdAutomationsIndexRoute
  WWorkspaceIdConnectorsIndexRoute: typeof WWorkspaceIdConnectorsIndexRoute
  WWorkspaceIdNotificationsIndexRoute: typeof WWorkspaceIdNotificationsIndexRoute
  WWorkspaceIdPeopleIndexRoute: typeof WWorkspaceIdPeopleIndexRoute
  WWorkspaceIdProductionIndexRoute: typeof WWorkspaceIdProductionIndexRoute
  WWorkspaceIdScheduleIndexRoute: typeof WWorkspaceIdScheduleIndexRoute
  WWorkspaceIdSkillsIndexRoute: typeof WWorkspaceIdSkillsIndexRoute
  WWorkspaceIdWorkflowsIndexRoute: typeof WWorkspaceIdWorkflowsIndexRoute
}

const WWorkspaceIdRouteChildren: WWorkspaceIdRouteChildren = {
  WWorkspaceIdConnectedWorkRoute: WWorkspaceIdConnectedWorkRoute,
  WWorkspaceIdCustomizeRoute: WWorkspaceIdCustomizeRoute,
  WWorkspaceIdMemoryRoute: WWorkspaceIdMemoryRoute,
  WWorkspaceIdOverviewRoute: WWorkspaceIdOverviewRoute,
  WWorkspaceIdUsageRoute: WWorkspaceIdUsageRoute,
  WWorkspaceIdIndexRoute: WWorkspaceIdIndexRoute,
  WWorkspaceIdAgentsAgentIdRoute: WWorkspaceIdAgentsAgentIdRoute,
  WWorkspaceIdAutomationsAutomationIdRoute:
    WWorkspaceIdAutomationsAutomationIdRoute,
  WWorkspaceIdChannelsChannelIdRoute: WWorkspaceIdChannelsChannelIdRoute,
  WWorkspaceIdChannelsManageRoute: WWorkspaceIdChannelsManageRoute,
  WWorkspaceIdConversationsConversationIdRoute:
    WWorkspaceIdConversationsConversationIdRoute,
  WWorkspaceIdProductionAppIdRoute: WWorkspaceIdProductionAppIdRoute,
  WWorkspaceIdScheduleAutomationIdRoute: WWorkspaceIdScheduleAutomationIdRoute,
  WWorkspaceIdSkillsSkillIdRoute: WWorkspaceIdSkillsSkillIdRoute,
  WWorkspaceIdWorkflowsWorkflowIdRoute: WWorkspaceIdWorkflowsWorkflowIdRoute,
  WWorkspaceIdAgentsIndexRoute: WWorkspaceIdAgentsIndexRoute,
  WWorkspaceIdAutomationsIndexRoute: WWorkspaceIdAutomationsIndexRoute,
  WWorkspaceIdConnectorsIndexRoute: WWorkspaceIdConnectorsIndexRoute,
  WWorkspaceIdNotificationsIndexRoute: WWorkspaceIdNotificationsIndexRoute,
  WWorkspaceIdPeopleIndexRoute: WWorkspaceIdPeopleIndexRoute,
  WWorkspaceIdProductionIndexRoute: WWorkspaceIdProductionIndexRoute,
  WWorkspaceIdScheduleIndexRoute: WWorkspaceIdScheduleIndexRoute,
  WWorkspaceIdSkillsIndexRoute: WWorkspaceIdSkillsIndexRoute,
  WWorkspaceIdWorkflowsIndexRoute: WWorkspaceIdWorkflowsIndexRoute,
}

const WWorkspaceIdRouteWithChildren = WWorkspaceIdRoute._addFileChildren(
  WWorkspaceIdRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  ChatRoute: ChatRouteWithChildren,
  ConnectRoute: ConnectRoute,
  PairRoute: PairRoute,
  SettingsRoute: SettingsRouteWithChildren,
  ConnectCallbackRoute: ConnectCallbackRoute,
  WWorkspaceIdRoute: WWorkspaceIdRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
